import React from "react";
import fields from "./fields";
import { Box, Button, TextField, Typography, useTheme } from "@mui/material";
import { useCompany } from "../Provider";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { createYupSchema } from "../../../utilities/yupSchemaCreator";
const yupSchema = fields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const FormCurrency = ({ handleClose, currency }) => {
  const theme = useTheme();
  const {
    state: { selected: company },
    CreateCurrency,
  } = useCompany();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = async (values) => {
    try {
      await CreateCurrency(company.id, values);
      handleClose();
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box sx={{ width: "100%", p: 2 }}>
        {fields.map((f, index) => (
          <div key={index}>
            <Typography variant="body2" component="h6" gutterBottom>
              {f.label}
            </Typography>
            <TextField
              label={f.label}
              name={f.name}
              error={!!errors[f.name]}
              helperText={errors[f.name]?.message}
              select={f.select}
              className={f.class}
              fullWidth
              required
              type={f.type}
              disabled={f.disabled}
              defaultValue={currency ? currency[f.name] : 0}
              sx={{
                width: theme.dimensions.width,
                mt: theme.dimensions.mt,
                mb: theme.dimensions.mb,
              }}
              inputProps={{
                ...register(f?.name),
                required: f.required,
              }}
              size="small"
            ></TextField>
          </div>
        ))}
        <Button
          type="submit"
          sx={{
            background: theme.color.blackBackground,
            color: "white",
            width: "100%",
            my: 2,
            "&:hover": { background: `${theme.color.black}` },
          }}
        >
          Save
        </Button>
        <Button
          onClick={handleClose}
          type="button"
          sx={{
            background: theme.color.gray200,
            color: "black",
            width: "100%",
            "&:hover": {
              background: `${theme.color.gray300}`,
            },
          }}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default FormCurrency;
